import { render, staticRenderFns } from "./ex-details.vue?vue&type=template&id=e8a6a1be&scoped=true&"
import script from "./ex-details.vue?vue&type=script&lang=js&"
export * from "./ex-details.vue?vue&type=script&lang=js&"
import style0 from "./ex-details.vue?vue&type=style&index=0&id=e8a6a1be&scoped=true&lang=scss&"
import style1 from "./ex-details.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a6a1be",
  null
  
)

export default component.exports